import { loadHbridge } from '@/utils/globalLoader';

async function initAppInfo() {
  const { Native, env } = await await loadHbridge();

  // 状态栏高度
  let statusBarHeight = 0;
  // 标题栏高度
  let titleBarHeight = 0;
  // appbar高度
  let AppBarHeight = 0;
  // appbar是否展示
  let appBarDisable = 'none';

  if (env.isEasyBikeApp || env.isAliMPMonitor || env.isAliMP) {
    titleBarHeight = 44;
    // 默认
    statusBarHeight = 30;
    appBarDisable = 'block';
    if (env.isAliMPMonitor || env.isAliMP) {
      //  小程序中，顶部状态栏高度，标题栏高度需要获取
      try {
        const res = await Native.callNative({
          classMap: 'SwitchBridge',
          method: 'getStatusHeight',
        });
        statusBarHeight = res.statusBarHeight;
        titleBarHeight = res.titleBarHeight;
      } catch (e) {
        // 老版本小程序，不绘制AppBar
        statusBarHeight = 0;
        titleBarHeight = 0;
        appBarDisable = 'none';
      }
    } else if (env.isAndroid) {
      // 安卓app全面屏不含h5容器不含状态栏，只能定义标题栏
      statusBarHeight = 0;
    } else if (env.isIOS) {
      // IOS App 状态栏高度获取系统的，标题栏采用默认44
      try {
        const res = await Native.callNative({
          classMap: 'SwitchBridge',
          method: 'getStatusHeight',
        });
        statusBarHeight = res.statusBarHeight;
      } catch (e) {
        statusBarHeight = 30;
      }
    }

    AppBarHeight = statusBarHeight + titleBarHeight;
  }

  window.localStorage.setItem('app-bar-config', JSON.stringify({
    statusBarHeight,
    titleBarHeight,
    AppBarHeight,
    appBarDisable,
  }));

  const _root = document.querySelector(':root');
  _root.style.setProperty('--status-bar-height', `${statusBarHeight}px`);
  _root.style.setProperty('--title-bar-height', `${titleBarHeight}px`);
  _root.style.setProperty('--app-bar-height', `${AppBarHeight}px`);
  _root.style.setProperty('--app-bar-disable', appBarDisable);
}

loadHbridge().then(async (r) => {
  const { env, Native } = r;

  if (env.isEasyBikeApp) {
    // // 隐藏h5容器自带的进度条，暂仅安卓支持
    // Native.callNative({
    //   classMap: 'NavBar',
    //   method: 'showProgressView',
    //   params: {
    //     isShow: false,
    //   },
    // });

    // // 隐藏顶部导航条
    // Native.toggleNavBar({ isShow: false });

    if (env.isAndroid) {
      // 修改状态栏颜色
      Native.callNative({
        classMap: 'NavBar',
        method: 'setStatusBarColor',
        params: { colorCode: '#ffffff' },
      });
    }
  }

  initAppInfo();
});
